import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Box, Dropdown, Optional } from '@honda-canada/design-system-react';
import { useFinance } from '../SelectProductsContext/SelectProductsProvider';
import { generateFinanceOptions, generateTermOptions, pushGtmFinanceOptions } from './service/utils';
import getDropdownOptionsData, { optionsKeys } from '../../utils/getDropdownOptionsData';
import useDropdownOptions from '../../hooks/useDropdownOptions';

import themeStyles from '../SelectProducts/styles/DropDownSelectors.styles';

const DropdownLabel = themeStyles.apply(Box, 'DropdownLabel');
const SelectorWrapper = themeStyles.apply(Box, 'SelectorWrapper');
const DropdownWrapper = themeStyles.apply(Box, 'DropdownWrapper');

const FinanceOptions = ({ financeOptions }) => {
  const pspFinanceOptions = generateFinanceOptions(financeOptions?.keys);
  const [finance, setFinance] = useFinance();

  const termOptions = financeOptions?.[finance.options]?.termOptions;
  const pspTermOptions = generateTermOptions(termOptions);

  const { dropdownOptions } = useDropdownOptions();
  const [yearData, modelData, transmissionData] = getDropdownOptionsData(dropdownOptions, [
    optionsKeys.year,
    optionsKeys.model,
    optionsKeys.transmission,
  ]);

  const modelName = modelData?.text;
  const modelYear = yearData?.value;
  const modelTransmission = transmissionData?.value;

  const { t } = useTranslation();
  return (
    <DropdownWrapper isFinance>
      <SelectorWrapper data-testid="cy-finance-options" isFinance>
        <DropdownLabel htmlFor="Finance options">{t('Sub-apps.PriceAndFinance.financeOptionsLabel')}</DropdownLabel>
        <Optional when={pspFinanceOptions}>
          <Dropdown
            defaultValue={finance.options}
            options={pspFinanceOptions}
            onChange={value => {
              setFinance({ options: value });
              pushGtmFinanceOptions(value, finance?.term, `${modelYear}: ${modelTransmission}: ${modelName}`);
            }}
            name={finance.options}
            selectedValue={finance.options}
            styling="secondary"
            ariaLabel={t('Sub-apps.PriceAndFinance.financeOptionsLabel')}
          />
        </Optional>
      </SelectorWrapper>
      <SelectorWrapper data-testid="cy-term-options" isFinance>
        <DropdownLabel htmlFor="Term by month">{t('Sub-apps.PriceAndFinance.termByMonthLabel')}</DropdownLabel>
        <Optional when={pspTermOptions}>
          <Dropdown
            defaultValue={finance.term}
            options={pspTermOptions}
            onChange={value => {
              setFinance({ term: value });
              pushGtmFinanceOptions(finance?.options, value, `${modelYear}: ${modelTransmission}: ${modelName}`);
            }}
            name={finance.term}
            selectedValue={finance.term}
            styling="secondary"
            ariaLabel={t('Sub-apps.PriceAndFinance.termByMonthLabel')}
          />
        </Optional>
      </SelectorWrapper>
    </DropdownWrapper>
  );
};

FinanceOptions.propTypes = {
  financeOptions: PropTypes.shape({
    keys: PropTypes.arrayOf(PropTypes.string),
  }),
};

export default FinanceOptions;
